import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { Sparkles, Star, Clock, ShieldCheck, Home } from 'lucide-react';
export const Hero = () => {
  return <section className="relative pt-12 pb-24 md:pt-20 md:pb-32 overflow-hidden" data-id="element-111">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none" data-id="element-112">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] rounded-full bg-accent-rose/20 blur-3xl" data-id="element-113" />
        <div className="absolute bottom-[-10%] left-[-10%] w-[600px] h-[600px] rounded-full bg-beige/40 blur-3xl" data-id="element-114" />
      </div>

      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center" data-id="element-115">
        <FadeIn direction="right" className="max-w-2xl" data-id="element-116">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/60 backdrop-blur-sm border border-white/40 text-sm font-medium text-text-brown mb-6" data-id="element-117">
            <Sparkles className="w-4 h-4 text-gold-soft" data-id="element-118" />
            <span data-id="element-119">Método Emprendimiento Aesthetic™</span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl leading-[1.1] mb-6" data-id="element-120">
            Empezá tu propio{' '}
            <span className="italic text-accent-rose-deep" data-id="element-121">
              emprendimiento aesthetic
            </span>{' '}
            desde casa.
          </h1>

          <p className="text-lg md:text-xl text-text-brown/90 mb-4 leading-relaxed font-medium" data-id="element-122">
            Aprendé a crear y vender <strong data-id="element-123">velas artesanales premium</strong>{' '}
            por Instagram.
          </p>

          <p className="text-base md:text-lg text-text-brown/70 mb-8 leading-relaxed" data-id="element-124">
            Sin experiencia. Sin creatividad. Sin grandes inversiones.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-10" data-id="element-125">
            <Button data-id="element-126">QUIERO EMPEZAR</Button>
          </div>

          <div className="grid grid-cols-2 gap-4 text-sm text-text-brown font-medium" data-id="element-127">
            <div className="flex items-center gap-2" data-id="element-128">
              <Clock className="w-4 h-4 text-accent-rose-deep shrink-0" data-id="element-129" />{' '}
              Acceso inmediato
            </div>
            <div className="flex items-center gap-2" data-id="element-130">
              <Star className="w-4 h-4 text-accent-rose-deep shrink-0" data-id="element-131" /> Para
              principiantes
            </div>
            <div className="flex items-center gap-2" data-id="element-132">
              <ShieldCheck className="w-4 h-4 text-accent-rose-deep shrink-0" data-id="element-133" />{' '}
              Baja inversión
            </div>
            <div className="flex items-center gap-2" data-id="element-134">
              <Home className="w-4 h-4 text-accent-rose-deep shrink-0" data-id="element-135" /> 100%
              desde casa
            </div>
          </div>
        </FadeIn>

        <FadeIn direction="left" delay={0.2} className="relative" data-id="element-136">
          <div className="relative rounded-[2rem] overflow-hidden shadow-2xl aspect-[4/5] md:aspect-auto md:h-[600px]" data-id="element-137">
            <img src="https://images.unsplash.com/photo-1603006905003-be475563bc59?auto=format&fit=crop&q=80" alt="Mujer emprendiendo con velas aesthetic" className="w-full h-full object-cover" data-id="element-138" />
            <div className="absolute inset-0 bg-gradient-to-t from-text-dark/40 to-transparent" data-id="element-139" />

            {/* Floating Trust Badge */}
            <div className="absolute bottom-6 left-6 right-6 glass-panel rounded-2xl p-4 flex items-center gap-4" data-id="element-140">
              <div className="flex -space-x-3" data-id="element-141">
                {[1, 2, 3, 4].map(i => <img key={i} src={`https://i.pravatar.cc/100?img=${i + 10}`} className="w-10 h-10 rounded-full border-2 border-white" alt="Alumna" data-id="element-142" />)}
              </div>
              <div data-id="element-143">
                <div className="flex text-gold-soft text-sm" data-id="element-144">
                  <Star className="w-4 h-4 fill-current" data-id="element-145" />
                  <Star className="w-4 h-4 fill-current" data-id="element-146" />
                  <Star className="w-4 h-4 fill-current" data-id="element-147" />
                  <Star className="w-4 h-4 fill-current" data-id="element-148" />
                  <Star className="w-4 h-4 fill-current" data-id="element-149" />
                </div>
                <p className="text-xs font-medium text-text-dark mt-1" data-id="element-150">
                  +2.500 alumnas activas
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};